var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertStyled, ItemAlertStyled, HeaderAlertStyled, HeaderContentAlertStyled, BodyAlertStyled, BodyButtonAlertStyled, } from './styled';
import Button from '../Button';
import Icon from '../Icon';
import IconButton from '../IconButton';
import { TucarTheme } from '../theme';
const Alert = (_a) => {
    var { children, onClose } = _a, props = __rest(_a, ["children", "onClose"]);
    const { variant, title, buttonProps } = props;
    const { onClick } = buttonProps || {};
    const iconAlert = () => {
        switch (variant) {
            case 'success':
                return { name: 'checkCircleRounded', color: TucarTheme.colors.green600 };
            case 'error':
                return { name: 'errorRounded', color: TucarTheme.colors.error500 };
            default:
                return { name: 'warningRounded', color: TucarTheme.colors.warning600 };
        }
    };
    return (_jsxs(AlertStyled, Object.assign({}, props, { children: [_jsxs(HeaderAlertStyled, { children: [_jsx(ItemAlertStyled, Object.assign({ variant: variant }, { children: _jsx(Icon, Object.assign({}, iconAlert())) })), _jsxs(HeaderContentAlertStyled, { children: [_jsx("p", Object.assign({ style: TucarTheme.typography.body2 }, { children: title })), _jsx(IconButton, { "data-testid": "clearButtonAlert", onClick: onClose, variant: "ghost", iconProps: { name: 'clearRounded', color: '#17171C', size: '24px' } })] })] }), _jsxs(BodyAlertStyled, { children: [children, onClick && (_jsx(BodyButtonAlertStyled, Object.assign({ "data-testid": "actionButtonAlert" }, { children: _jsx(Button, Object.assign({}, buttonProps)) })))] })] })));
};
export default Alert;
//# sourceMappingURL=index.js.map